export const SAO_TOT: Record<string, string> = {
  thien_duc: "Thiên Đức",
  thoi_duc: "Thời Đức",
  thien_duc_hop: "Thiên Đức Hợp",
  nguyet_duc: "Nguyệt Đức",
  nguyet_duc_hop: "Nguyệt Đức Hợp",
  thien_hy: "Thiên Hỷ",
  thien_phu: "Thiên Phú",
  thien_quy: "Thiên Quý",
  thien_xa: "Thiên Xá",
  sinh_khi: "Sinh Khí",
  thien_phuc: "Thiên Phúc",
  thien_thanh: "Thiên Thành",
  thien_quan: "Thiên Quan",
  thien_ma: "Thiên Mã",
  thien_tai: "Thiên Tài",
  dia_tai: "Địa Tài",
  nguyet_tai: "Nguyệt Tài",
  nguyet_an: "Nguyệt Ân",
  nguyet_khong: "Nguyệt Không",
  minh_tinh: "Minh Tinh",
  thanh_tam: "Thánh Tâm",
  ngu_phu: "Ngũ Phú",
  loc_kho: "Lộc Khố",
  phuc_sinh: "Phúc Sinh",
  cat_khanh: "Cát Khánh",
  am_duc: "Âm Đức",
  u_vi_tinh: "U Vi Tinh",
  man_duc_tinh: "Mãn Đức Tinh",
  kinh_tam: "Kính Tâm",
  tue_hop: "Tuế Hợp",
  nguyet_giai: "Nguyệt Giải",
  quan_nhat: "Quan Nhật",
  hoat_dieu: "Hoạt Diệu",
  giai_than: "Giải Thần",
  pho_ho: "Phổ Hộ",
  ich_hau: "Ích Hậu",
  tuc_the: "Tục Thế",
  yeu_yen: "Yếu Yên",
  dich_ma: "Dịch Mã",
  tam_hop: "Tam Hợp",
  luc_hop: "Lục Hợp",
  mau_thuong: "Mẫu Thương",
  phuc_hau: "Phúc Hậu",
  dai_hong_sa: "Đại Hồng Sa",
  dan_nhat: "Dân Nhật",
  hoang_an: "Hoàng Ân",
  thanh_long: "Thanh Long",
  minh_duong: "Minh Đường",
  kim_duong: "Kim Đường",
  ngoc_duong: "Ngọc Đường",
  thien_thuy: "Thiên Thụy",
  ngu_hop: "Ngũ Hợp",
  thien_an: "Thiên Ân",
  sat_cong: "Sát Cống",
  truc_tinh: "Trực Tinh",
  nhan_chuyen: "Nhân Chuyên",
  tieu_hao: "Tiểu Hao",
};

export const SAO_XAU: Record<string, string> = {
  thien_cuong: "Thiên Cương",
  thien_lai: "Thiên Lại",
  thien_nguc_thien_hoa: "Thiên Ngục, Thiên Hỏa",
  tieu_hong_sa: "Tiểu Hồng Sa",
  dai_hao: "Đại Hao",
  tieu_hao: "Tiểu Hao",
  nguyet_pha: "Nguyệt Phá",
  kiep_sat: "Kiếp Sát",
  dia_pha: "Địa Phá",
  tho_phu: "Thổ Phủ",
  tho_on: "Thổ Ôn",
  thien_on: "Thiên Ôn",
  thu_tu: "Thụ Tử",
  hoang_vu: "Hoang Vu",
  thien_tac: "Thiên Tặc",
  dia_tac: "Địa Tặc",
  hoa_tai: "Hỏa Tai",
  nguyet_hoa_doc_hoa: "Nguyệt Hỏa, Độc Hỏa",
  nguyet_yem_dai_hoa: "Nguyệt Yếm Đại Họa",
  nguyet_hu: "Nguyệt Hư",
  hoang_sa: "Hoàng Sa",
  luc_bat_thanh: "Lục Bất Thành",
  nhan_cach: "Nhân Cách",
  than_cach: "Thần Cách",
  phi_ma_sat: "Phi Ma Sát",
  ngu_quy: "Ngũ Quỷ",
  bang_tieu_ngoa_ham: "Băng Tiêu Ngọa Hãm",
  ha_khoi_cau_giao: "Hà Khôi, Cẩu Giảo",
  vang_vong: "Vãng Vong",
  cuu_khong: "Cửu Không",
  trung_tang: "Trùng Tang",
  trung_phuc: "Trùng Phục",
  chu_tuoc_hac_dao: "Chu Tước Hắc Đạo",
  bach_ho: "Bạch Hổ",
  huyen_vu: "Huyền Vũ",
  cau_tran: "Câu Trận",
  loi_cong: "Lôi Công",
  co_than: "Cô Thần",
  qua_tu: "Quả Tú",
  sat_chu: "Sát Chủ",
  nguyet_hinh: "Nguyệt Hình",
  toi_chi: "Tội Chỉ",
  nguyet_kien_chuyen_sat: "Nguyệt Kiến Chuyển Sát",
  thien_dia_chinh_chuyen: "Thiên Địa Chính Chuyển",
  thien_dia_chuyen_sat: "Thiên Địa Chuyển Sát",
  lo_ban_sat: "Lỗ Ban Sát",
  phu_dau_sat: "Phủ Đầu Sát",
  tam_tang: "Tam Tang",
  ngu_hu: "Ngũ Hư",
  tho_cam: "Thổ Cấm",
  ly_sang: "Ly Sàng",
  tinh_thoi_co_qua: "Tứ Thời Cô Quả",
  khong_phong: "Không Phòng",
  am_thac: "Âm Thác",
  duong_thac: "Dương Thác",
  quy_khoc: "Quỷ Khốc",
  thien_an: "Thiên Ân",
  sat_cong: "Sát Cống",
  nhan_chuyen: "Nhân Chuyên",
  truc_tinh: "Trực Tinh",
  tu_thoi_dai_mo: "Tứ Thời Đại Mộ",
};

export const CONG_VIEC_MAPPING: Record<string, string> = {
  cung_le: "Cúng lễ",
  cau_phuc: "Cầu phúc",
  cau_tai: "Cầu tài",
  cau_tu: "Cầu tự",
  dong_tho: "Động thổ",
  do_mai: "Đổ mái",
  nhap_trach: "Nhập trạch",
  pha_do: "Phá dỡ",
  sua_chua: "Sửa chữa",
  khai_truong: "Khai trương",
  mo_cua_hang: "Mở cửa hàng",
  dinh_hon: "Đính hôn",
  an_hoi: "Ăn hỏi",
  cuoi_ga: "Cưới gả",
  ky_ket: "Ký kết",
  giao_dich: "Giao dịch",
  nham_chuc: "Nhậm chức",
  chuyen_nha: "Chuyển nhà",
  chuyen_bep: "Chuyển bếp",
  an_tang: "An táng",
  cai_tang: "Cải táng",
  to_tung: "Tố tụng",
  xuat_hanh: "Xuất hành",
  mai_tang: "Mai táng",
  xay_tuong: "xây tường",
  dap_bo: "đắp bờ",
};

export const NGAY_HOANGDAO_HACDAO_MAPPING: Record<string, string> = {
  thanh_long_hoang_dao: "Thanh Long Hoàng Đạo",
  minh_duong_hoang_dao: "Minh Đường Hoàng Đạo",
  kim_quy_hoang_dao: "Kim Quỹ Hoàng Đạo",
  kim_duong_hoang_dao: "Kim Đường Hoàng Đạo",
  ngoc_duong_hoang_dao: "Ngọc Đường Hoàng Đạo",
  tinh_menh_hoang_dao: "Tư Mệnh Hoàng Đạo",
  thien_hinh_hac_dao: "Thiên Hình Hắc Đạo",
  chu_tuoc_hac_dao: "Chu Tước Hắc Đạo",
  bach_ho_hac_dao: "Bạch Hổ Hắc Đạo",
  thien_lao_hac_dao: "Thiên Lao Hắc Đạo",
  nguyen_vu_hac_dao: "Nguyên Vũ Hắc Đạo",
  cau_tran_hac_dao: "Câu Trần Hắc Đạo",
};

export const WEEKDAY_MAPPING: Record<string, string> = {
  thu_hai: "Thứ hai",
  thu_ba: "Thứ ba",
  thu_tu: "Thứ tư",
  thu_nam: "Thứ năm",
  thu_sau: "Thứ sáu",
  thu_bay: "Thứ bảy",
  chu_nhat: "Chủ nhật",
};

export const CAN_CHI: Record<string, string> = {
  canh: "Canh",
  tan: "Tân",
  nham: "Nhâm",
  quy: "Quý",
  giap: "Giáp",
  at: "Ất",
  binh: "Bính",
  dinh: "Đinh",
  mau: "Mậu",
  ky: "Kỷ",
  than: "Thân",
  dau: "Dậu",
  tuat: "Tuất",
  hoi: "Hợi",
  tys: "Tý",
  ty: "Tý",
  suu: "Sửu",
  dan: "Dần",
  mao: "Mão",
  thin: "Thìn",
  tyj: "Tỵ",
  ngo: "Ngọ",
  mui: "Mùi",
  giap_tys: "Giáp Tý",
  giap_dan: "Giáp Dần",
  giap_thin: "Giáp Thìn",
  giap_ngo: "Giáp Ngọ",
  giap_than: "Giáp Thân",
  giap_tuat: "Giáp Tuất",
  at_suu: "Ất Sửu",
  at_mao: "Ất Mão",
  at_tyj: "Ất Tỵ",
  at_mui: "Ất Mùi",
  at_dau: "Ất Dậu",
  at_hoi: "Ất Hợi",
  binh_tys: "Bính Tý",
  binh_dan: "Bính Dần",
  binh_thin: "Bính Thìn",
  binh_ngo: "Bính Ngọ",
  binh_than: "Bính Thân",
  binh_tuat: "Bính Tuất",
  dinh_suu: "Đinh Sửu",
  dinh_mao: "Đinh Mão",
  dinh_tyj: "Đinh Tỵ",
  dinh_mui: "Đinh Mùi",
  dinh_dau: "Đinh Dậu",
  dinh_hoi: "Đinh Hợi",
  mau_tys: "Mậu Tý",
  mau_dan: "Mậu Dần",
  mau_thin: "Mậu Thìn",
  mau_ngo: "Mậu Ngọ",
  mau_than: "Mậu Thân",
  mau_tuat: "Mậu Tuất",
  ky_suu: "Kỷ Sửu",
  ky_mao: "Kỷ Mão",
  ky_tyj: "Kỷ Tỵ",
  ky_mui: "Kỷ Mùi",
  ky_dau: "Kỷ Dậu",
  ky_hoi: "Kỷ Hợi",
  canh_tys: "Canh Tý",
  canh_dan: "Canh Dần",
  canh_thin: "Canh Thìn",
  canh_ngo: "Canh Ngọ",
  canh_than: "Canh Thân",
  canh_tuat: "Canh Tuất",
  tan_suu: "Tân Sửu",
  tan_mao: "Tân Mão",
  tan_tyj: "Tân Tỵ",
  tan_mui: "Tân Mùi",
  tan_dau: "Tân Dậu",
  tan_hoi: "Tân Hợi",
  nham_tys: "Nhâm Tý",
  nham_dan: "Nhâm Dần",
  nham_thin: "Nhâm Thìn",
  nham_ngo: "Nhâm Ngọ",
  nham_than: "Nhâm Thân",
  nham_tuat: "Nhâm Tuất",
  quy_suu: "Quý Sửu",
  quy_mao: "Quý Mão",
  quy_tyj: "Quý Tỵ",
  quy_mui: "Quý Mùi",
  quy_dau: "Quý Dậu",
  quy_hoi: "Quý Hợi",
};

export const NGU_HANH: Record<string, string> = {
  kim: "Kim",
  moc: "Mộc",
  tho: "Thổ",
  thuy: "Thủy",
  hoa: "Hỏa",
};

export const TIET_KHI: Record<string, string> = {
  xuan_phan: "Xuân phân",
  thanh_minh: "Thanh minh",
  coc_vu: "Cốc vũ",
  lap_ha: "Lập hạ",
  tieu_man: "Tiểu mãn",
  mang_chung: "Mang chủng",
  ha_chi: "Hạ chí",
  tieu_thu: "Tiểu thử",
  dai_thu: "Đại thử",
  lap_thu: "Lập thu",
  xu_thu: "Xử thử",
  bach_lo: "Bạch lộ",
  thu_phan: "Thu phân",
  han_lo: "Hàn lộ",
  suong_giang: "Sương giáng",
  lap_dong: "Lập đông",
  tieu_tuyet: "Tiểu tuyết",
  dai_tuyet: "Đại tuyết",
  dong_chi: "Đông chí",
  tieu_han: "Tiểu hàn",
  dai_han: "Đại hàn",
  lap_xuan: "Lập xuân",
  vu_thuy: "Vũ thủy",
  kinh_trap: "Kinh trập",
};

export const TRUC: Record<string, string> = {
  truc_kien: "Kiến",
  truc_tru: "Trừ",
  truc_man: "Mãn",
  truc_binh: "Bình",
  truc_dinh: "Định",
  truc_chap: "Chấp",
  truc_pha: "Phá",
  truc_nguy: "Nguy",
  truc_thanh: "Thành",
  truc_thu: "Thu",
  truc_khai: "Khai",
  truc_be: "Bế",
};

export const TU: Record<string, string> = {
  tinh_hu: "Hư",
  tinh_nguy: "Nguy",
  tinh_that: "Thất",
  tinh_bich: "Bích",
  tinh_khue: "Khuê",
  tinh_lau: "Lâu",
  tinh_vij: "Vị",
  tinh_mao: "Mão",
  tinh_tat: "Tất",
  tinh_chuy: "Chủy",
  tinh_sam: "Sâm",
  tinh_tinhr: "Tỉnh",
  tinh_quy: "Quỷ",
  tinh_lieu: "Liễu",
  tinh_tinh: "Tinh",
  tinh_truong: "Trương",
  tinh_duc: "Dực",
  tinh_chan: "Chẩn",
  tinh_giac: "Giác",
  tinh_cang: "Cang",
  tinh_de: "Đê",
  tinh_phong: "Phòng",
  tinh_tam: "Tâm",
  tinh_vix: "Vĩ",
  tinh_co: "Cơ",
  tinh_dau: "Đẩu",
  tinh_nguu: "Ngưu",
  tinh_nu: "Nữ",
};

export const BACH_KY: Record<string, string> = {
  nguyet_ky: "Nguyệt Kỵ",
  tam_nuong: "Tam Nương",
  tho_tu: "Thọ Tử",
  sat_chu_am: "Sát Chủ Âm",
  sat_chu_duong: "Sát Chủ Dương",
  vang_vong: "Vãng Vong",
  nguyet_pha: "Nguyệt Phá",
  khong_pham: "Không Phạm",
  tue_pha: "Tuế Phá",
};
// Map key zodiac -> key ảnh
export const ZODIAC_IMAGE_KEY_MAP: Record<string, string> = {
  mao: "mao",
  tyj: "ty",
  tys: "ti",
  ti: "ti",
  ty: "ty",
  suu: "suu",
  dan: "dan",
  thin: "thin",
  ngo: "ngo",
  mui: "mui",
  than: "than",
  dau: "dau",
  tuat: "tuat",
  hoi: "hoi",
};